module.exports = __webpack_public_path__ + "img/bg-igloo.25b6a0ae.jpg";